const paymentMethods = require("./paymentMethods");
const inAppPayments = [
  paymentMethods.creditCard,
  paymentMethods.payPal,
  paymentMethods.bizum,
];
module.exports = inAppPayments;
